import React from 'react';
import { useAppDispatch } from 'ducks/hooks';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import Box from 'ui/Box';
import MobileDrawer from 'components/MobileDrawer/MobileDrawer';
import { isStandardFramesSheetVisible, setStandardFramesSheetVisible } from '../AutofillPax';
import ChangeFrameColor from '../widgets/ChangeFrameColor';
import {
  SolutionDepthToggle,
  SolutionHeightToggle
} from 'rangeConfig/pax/widgets/changeSize/ChangeSolutionSize';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import Title from 'ui/Typography/Title';
import { getFilterState, getMarketProducts, getToggleState, selectGroup } from 'ducks/products';
import findAddableFrames from 'rangeConfig/pax/widgets/addFrame/findAddableFrames';
import ListItem from 'ui/PlainList/ListItem';
import ProductCard from 'components/ProductSidebar/ProductCard/ProductCard';
import { useCore } from 'contexts/core';
import framesProductListConfig from 'rangeConfig/pax/productGroups/frames/productListConfig';
import { store } from 'ducks';

const AutoFillMenuWrapper = styled.div`
  overflow-y: auto;
  height: 100%;
`;

const List = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const StandardFrameSheet = () => {
  const dispatch = useAppDispatch();
  const sheetVisible = useSelector(isStandardFramesSheetVisible);
  const { formatMessage } = useIntl();
  const allProducts = useSelector(getMarketProducts);
  const filterState = useSelector(getFilterState);
  const toggleState = useSelector(getToggleState);
  const coreApi = useCore();

  const onClose = () => {
    dispatch(setStandardFramesSheetVisible(false));
    dispatch(selectGroup(''));
  };

  const color = filterState('frames', 'design').design;
  const height = toggleState('frames', 'height').selected;
  const depth = toggleState('frames', 'depth').selected;
  const frameProducts = findAddableFrames(allProducts, color, height, depth);

  const frameProductListConfig = framesProductListConfig();

  return sheetVisible ? (
    <MobileDrawer
      open={sheetVisible}
      onDismiss={onClose}
      title={formatMessage({ id: 'storageone.autofillPaxTabTitleSingleFrames' })}
    >
      <AutoFillMenuWrapper>
        <Box margin="md">
          <ChangeFrameColor />
          <Title
            mt="xl"
            id="autofill-change-depth-heading"
            type={ThemeFontStyleTypeEnum.headingXSmall}
          >
            {formatMessage({ id: 'storageone.height' })}
          </Title>
          <SolutionHeightToggle />
          <Title
            mt="xl"
            id="autofill-change-depth-heading"
            type={ThemeFontStyleTypeEnum.headingXSmall}
          >
            {formatMessage({ id: 'storageone.depth' })}
          </Title>
          <SolutionDepthToggle />
          <Title
            mt="xl"
            id="autofill-change-depth-heading"
            type={ThemeFontStyleTypeEnum.headingXSmall}
          >
            {formatMessage({ id: 'storageone.newMenuSubmenuHeading' })}
          </Title>

          <List>
            {frameProducts.map(product => (
              <ListItem key={product.coreProductId} data-testid={product.coreProductId}>
                <ProductCard
                  product={product}
                  handleClick={() =>
                    frameProductListConfig.behaviors.productClicked?.forEach(b =>
                      b({
                        coreApi,
                        rootState: store.getState(),
                        props: product,
                        dispatch
                      })
                    )
                  }
                  infoButtonAriaLabel={'storageone.selectedMenuInteriorsCombinationsMenuTitle'}
                  cardSubtitle={frameProductListConfig.cardsSubtitle}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </AutoFillMenuWrapper>
    </MobileDrawer>
  ) : (
    <></>
  );
};

export default StandardFrameSheet;
